// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__fa5Ov","productName":"Table_productName__2itph"};